import './MainBlock.css';
import book from '../../book.png';
import StripeButton from './StripeButton';
import PaypalBtn from './PaypalBtn';


function MainBlock(){
    return(

        <>
        
        <section  id="mainBackground" class="hero ">
            <div id="layer" class="hero-body">
            <div class="center">
            <div class="columns">
              <div class="column">  
                <div id="flexCol" class="center">
                    <p id="mainText" class="title">Buy now for 2.99$ (<span id="crossed">8.99$</span>) </p>
                    <div class="stars"><i class="fas fa-star"/><i class="fas fa-star"/><i class="fas fa-star"/><i class="fas fa-star"/><i class="fas fa-star"/></div>
                    <p id="desc"> Today is going to be the first day, the first day of your new life. Join me, let me guide you to your own potential and see yourself accomplishing the goals you set for yourself. </p>
                    <StripeButton/>
                    <p id="or" >Or</p>
                    <PaypalBtn/>
                </div>
                </div>
                <div id="bookColumn" class="column" >
                    <div class="center">
                    <img id="bookImg" src={book} height="522.717px" width="326.7px" alt="ebook"/>
                    </div>
                </div>  
            </div> 
            </div>
            </div>
        </section>
       
        </>

    );
}

export default MainBlock;